export { default } from './CookieConsentPrompt';
